import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { HomeService } from '../../../../../services/home.service';
import { forkJoin, Observable, of } from 'rxjs';
import { am4geodata_peruHigh, CONSTANTS, ROUTES_URL } from '@app/core';
import { environment } from 'src/environments/environment';
import { IResumenUniversidadPrograma } from 'src/app/modules/home/interfaces/resumen-universidad-programa.interface';

@Component({
  selector: 'app-section-home-info-principal',
  templateUrl: './section-home-info-principal.component.html',
  styleUrls: ['./section-home-info-principal.component.scss']
})
export class SectionHomeInfoPrincipalComponent implements OnInit {

  varAnioCurso: string = environment.anioCurso;
  varPeriodoCurso:string = environment.periodoCurso;
  cantidadUniversidades: number = 100;
  myloading= true;

  cantidadCarreras: number = 5000;
  nombreDepartamento: string = "";
  ubigeoSelected: string = null;
  chartMapa: any = [];
  ProgramaResumen: any = [];
  @ViewChild('chartElement') chartElement: ElementRef<HTMLElement>;

  cantidadCarreras$: Observable<string>;
  cantidadUniversidades$: Observable<string>;
  cantidadEstudiantes$: Observable<string>;
  cantidadDocentes$: Observable<string>;
  cantidadPostulantes$: Observable<string>;
  programaResumen$: Observable<IResumenUniversidadPrograma>;


  
  constructor(
    // private modalService: NgbModal,
    private router: Router, private homeService: HomeService) { }

  chart: am4maps.MapChart;
  lastSelected: any;

  ngOnInit() {
   this.loadCantidadPeru();
  }
  ngAfterViewInit() {
    this.generarMapa(this.nombreDepartamento);

  }

  loadCantidadPorDepartamento = (ubigeo, nombreDepartamento: string) => {
    this.myloading = true;
    this.nombreDepartamento = nombreDepartamento;
    this.ubigeoSelected = ubigeo;
  
    forkJoin({
      
      cantidadCarreras: this.homeService.getCantidadCarrerasPorDepartamentoDWH(ubigeo),
      cantidadUniversidades: this.homeService.getCantidadUniversidadesPorDepartamentoDWH(ubigeo),
      cantidadEstudiantes: this.homeService.getCantidadEstudiantesPorDepartamentoDWH(ubigeo),
      cantidadDocentes: this.homeService.getCantidadDocentesPorDepartamentoDWH(ubigeo),
      cantidadPostulantes: this.homeService.getCantidadPostulantesPorDepartamentoDWH(ubigeo),
      programaResumen: this.homeService.getObtenerEntidadesProgramaResumen()
    }).subscribe(
      (result) => {

        // Convertir los valores numéricos a cadenas y luego a observables
        this.cantidadCarreras$ = of(result.cantidadCarreras.toString());
        this.cantidadUniversidades$ = of(result.cantidadUniversidades.toString());
        this.cantidadEstudiantes$ = of(result.cantidadEstudiantes.toString());
        this.cantidadDocentes$ = of(result.cantidadDocentes.toString());
        this.cantidadPostulantes$ = of(result.cantidadPostulantes.toString());
        this.programaResumen$ = of(result.programaResumen);
        this.myloading = false;  // Ocultar el loading cuando todas las peticiones se completan
      },
      (error) => {
        console.error('Error al cargar los datos', error);
        this.myloading = false;  // Asegurarse de ocultar el loading en caso de error también
      }
    );
  };

  loadCantidadPeru = () => {
    this.nombreDepartamento = null;
    this.ubigeoSelected = null;
    
    // this.cantidadCarreras$ = this.homeService.getCantidadCarrerasDWH();
    this.cantidadUniversidades$ = this.homeService.getCantidadUniversidadesDWH();
    this.cantidadEstudiantes$ = this.homeService.getCantidadEstudiantesDWH();
    this.cantidadDocentes$ = this.homeService.getCantidadDocentesDWH();
    this.cantidadPostulantes$ = this.homeService.getCantidadPostulantesPorDepartamentoDWH("00");

    //  this.homeService.getObtenerEntidadesProgramaResumen().subscribe(
    //    (data) => {
  
    //      this.cantidadUniversidades$ = of(data.entidadesTotal.toString());
    //      this.cantidadPostulantes$ = of((data.postulantesTotal).toString());
    //      this.cantidadEstudiantes$ = of(data.matriculadosTotal.toString());
    //      this.cantidadDocentes$ = of(data.docentesTotal.toString());
    //     },
    //     (error) => {
    //       console.error('Error al obtener los datos:', error);
    //     }
    // );
    this.ubigeoSelected = '000000';
    this.myloading = false;
  }

  handleOpenFiltroUniversidades = () => {
    this.router.navigate([ROUTES_URL.UNIVERSIDADES.BUSQUEDA], { queryParams: { ubigeo: this.ubigeoSelected } });
  }

  handleOpenFiltroCarrera = () => {
    this.router.navigate([ROUTES_URL.PROGRAMAS.BUSQUEDA], { queryParams: { ubigeo: this.ubigeoSelected } });
  }

  handleOpenFiltroEstudiantes = () => {
    this.router.navigate([ROUTES_URL.COMUNIDAD.ESTUDIANTIL], { queryParams: { ubigeo: this.ubigeoSelected } });
  }

  handleOpenFiltroEstudiantePostulantes = () => {
    this.router.navigate([ROUTES_URL.COMUNIDAD.ESTUDIANTIL], { 
      queryParams: { ubigeo: this.ubigeoSelected },
      fragment: 'postulantes' // Aquí añadimos el fragmento
    });
  }

  handleOpenFiltroDocentes = () => {
    this.router.navigate([ROUTES_URL.COMUNIDAD.DOCENTES], { queryParams: { ubigeo: "000000" } });
  }

  generarMapa = (nombreDepartamento) => {

    am4core.useTheme(am4themes_animated);
    // Themes end

    /* Create map instance */
    this.chart = am4core.create(this.chartElement.nativeElement, am4maps.MapChart);

    /* Set map definition */
    this.chart.geodata = am4geodata_peruHigh;

    /* Set projection */
    this.chart.projection = new am4maps.projections.Miller();

    /* Create map polygon series */
    let polygonSeries = this.chart.series.push(new am4maps.MapPolygonSeries());

    /* Make map load polygon (like country names) data from GeoJSON */
    polygonSeries.useGeodata = true;

    /* Configure series */
    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.applyOnClones = true;
    polygonTemplate.togglable = true;
    polygonTemplate.tooltipText = "{name}";
    polygonTemplate.nonScalingStroke = true;
    polygonTemplate.strokeOpacity = 0.5;
    polygonTemplate.fill = am4core.color("#AFAFAF");
    polygonTemplate.showTooltipOn = 'hover';
    polygonTemplate.tooltipPosition = "fixed";

    polygonTemplate.events.on("hit", function (ev) {
      if (['PE-LMA', 'PE-LKT'].includes((ev.target.dataItem.dataContext as any).id)) {
        return;
      }

      if (this.lastSelected) {
        this.lastSelected.isActive = false;
        this.lastSelected.showTooltipOn = 'hover';
        this.lastSelected.isHover = false;
        this.lastSelected.hideTooltip();
      }

      //if (this.lastSelected !== ev.target) {
      this.lastSelected = ev.target;
      this.lastSelected.showTooltipOn = 'always';
      this.lastSelected.showTooltip();

      const selected = CONSTANTS.DATA_PERU.find(x => x.id == this.lastSelected.dataItem.dataContext.id);

      this.loadCantidadPorDepartamento(selected.ubigeo, selected.nombre_departamento);
      //}
    }, this);

    /* Create selected and hover states and set alternative fill color */
    let ss = polygonTemplate.states.create("active");
    ss.properties.fill = am4core.color("#00a19a");

    let hs = polygonTemplate.states.create("hover");
    hs.properties.fill = am4core.color("#00a19a");

    // // Small map
    // chart.smallMap = new am4maps.SmallMap();
    // // Re-position to top right (it defaults to bottom left)
    // chart.smallMap.align = "right";
    // chart.smallMap.valign = "top";
    // chart.smallMap.series.push(polygonSeries);

    // Zoom control
    this.chart.zoomControl = new am4maps.ZoomControl();
    this.chart.zoomControl.disabled = true;
    this.chart.zoomControl.disabled = true;
    this.chart.zoomControl.wheelable = false;
    this.chart.chartContainer.wheelable = false;
    this.chart.seriesContainer.draggable = false;
    this.chart.seriesContainer.resizable = false;
    this.chart.seriesContainer.events.disableType("doublehit");
    this.chart.chartContainer.background.events.disableType("doublehit");

  }

  handleClickInfoNacional = () => {
    this.chart.goHome();
    if (this.lastSelected) {   
      this.lastSelected.showTooltipOn = 'hover';
      this.lastSelected.isActive = false;
      this.lastSelected.isHover = false;
      this.lastSelected.hideTooltip();
    }
    this.loadCantidadPeru();
  }

}
